'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_BATCH_SIZE = 1000000;

/**
 * Fetches events from a specific contract with criteria
 */
var fetchContractEvents = function fetchContractEvents(contract, criteria) {
  var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BLOCK_BATCH_SIZE;
  var _criteria$eventName = criteria.eventName,
      eventName = _criteria$eventName === undefined ? 'allEvents' : _criteria$eventName,
      _criteria$fromBlock = criteria.fromBlock,
      fromBlock = _criteria$fromBlock === undefined ? 0 : _criteria$fromBlock,
      _criteria$toBlock = criteria.toBlock,
      toBlock = _criteria$toBlock === undefined ? 'latest' : _criteria$toBlock,
      _criteria$filter = criteria.filter,
      filter = _criteria$filter === undefined ? {} : _criteria$filter;


  var ranges = [];

  // Don't break up fetching if we can't calculate, or the range is small.
  if (toBlock === 'latest' || toBlock - fromBlock < batchSize) {
    ranges.push({
      fromBlock: fromBlock,
      toBlock: toBlock
    });
  } else {
    // Break down the fetch into multiples of a manageable range.
    for (var i = fromBlock; i <= toBlock; i += batchSize) {
      var nextToBlock = i + (batchSize - 1);
      // Limit to never above the toBlock.
      ranges.push({ fromBlock: i, toBlock: nextToBlock <= toBlock ? nextToBlock : toBlock });
    }
  }
  return _bluebird2.default.reduce(ranges.map(function (range) {
    return contract.getPastEvents(eventName, {
      fromBlock: range.fromBlock,
      toBlock: range.toBlock,
      filter: filter
    });
  }), function (out, events) {
    return out.concat(events);
  });
};

exports.default = fetchContractEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/fetchContractEvents.js
// module id = 1284
// module chunks = 0